const methods =
[
  {id:1, text:'Contrat de domiciliation'},
  {id:2, text:'Contrat de location longue durée'},
  {id:4, text:'Réservation ponctuelle'},
  {id:-1, text:'Aucune'},
]

export {methods as default}



// WEBPACK FOOTER //
// ./client/utils/crm_distrib_methods.js